module.exports = __webpack_public_path__ + "static/media/bronze-icon.83d81e12.png";